/**
 * ——————————————————————————————
 * FUNCTION DEFINITIONS / GLOBALS
 * ——————————————————————————————
 */

// Toast notification. Optional `href`: clicking the toast navigates there.
function showToast(content, location, duration = 2500, href = null) {
  const toast = document.createElement("div");
  toast.classList.add("toast");
  toast.textContent = content;

  toast.classList.add(`toast-${location}`);
  document.body.appendChild(toast);
  if (href) toast.addEventListener("click", () => (window.location = href));
  setTimeout(() => {
    toast.classList.add("toast--active");
  }, 10);

  setTimeout(() => {
    toast.classList.remove("toast--active");
    toast.addEventListener(
      "transitionend",
      () => {
        toast.remove();
      },
      { once: true }
    );
  }, duration);
}

/**
 * ——————————————————————————————
 * FUNCTION EXECUTION (DOM READY)
 * ——————————————————————————————
 */

window.addEventListener("DOMContentLoaded", () => {
  // Attentive renders the BIS button as <button>TEXT</button> with no
  // inner span. Wrap the text in <span class="btn__text"> so the theme's
  // button text-alignment styles apply (matches the convention used by
  // other theme buttons). Attentive swaps textContent when signup state
  // changes (enabled ↔ disabled), so observe and re-wrap as needed.
  const wrapBisButtonText = () => {
    const btn = document.getElementById("attn-waitlist-trigger-btn");
    if (!btn || btn.querySelector(".btn__text")) return;
    const text = btn.textContent.trim();
    if (!text) return;
    btn.textContent = "";
    const span = document.createElement("span");
    span.className = "btn__text";
    span.textContent = text;
    btn.appendChild(span);
  };
  const bisTrigger = document.getElementById("attn-waitlist-trigger");
  if (bisTrigger) {
    wrapBisButtonText();
    new MutationObserver(wrapBisButtonText).observe(bisTrigger, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // A third-party script (originating from selectors.js / index.js —
  // exact source not confirmed) replaces the cart count with
  // <span class="cart-link__count">N</span>, missing the inner <span>
  // the theme's styles expect. Wrap the text node in a <span> so
  // .cart-link__count span styles apply.
  const wrapCartCountText = (el) => {
    if (
      !el ||
      el.nodeType !== 1 ||
      !el.matches?.(".cart-link__count") ||
      el.querySelector("span")
    ) {
      return;
    }
    const text = el.textContent.trim();
    if (!text) return;
    el.textContent = "";
    const inner = document.createElement("span");
    inner.textContent = text;
    el.appendChild(inner);
  };

  // theme:cartchanged (public/theme.js) triggers an async
  // ?sections=header refresh that replaces the inner HTML of the
  // header right-area, dropping any cart-count wrapping. Watch the
  // area for any DOM change and re-apply it. wrapCartCountText is a
  // no-op once the span exists, so the observer settles after one
  // extra pass and needs no cooldown (a cooldown would drop a
  // third-party rewrite landing just after our own write).
  const headerArea = document.querySelector(
    "#pageheader .logo-area__right__inner"
  );
  if (headerArea) {
    const refreshHeaderState = () => {
      headerArea
        .querySelectorAll(".cart-link__count")
        .forEach(wrapCartCountText);
    };

    // Run once on init in case anything is already malformed.
    refreshHeaderState();

    new MutationObserver(refreshHeaderState).observe(headerArea, {
      childList: true,
      subtree: true,
    });
  }
});
